const styles = {
  logoContainer: { display: 'flex', justifyContent: 'center', mt: 3 },
  container: { width: { sm: 'fit-content' }, zIndex: 1 },
  paper: {
    pt: {
      xs: 9,
      sm: 5,
    },
    px: {
      sm: 5,
    },
    pb: {
      sm: 5,
    },
    width: {
      xs: '100%',
      sm: 440,
    },
  },
  title: {
    mb: 4,
    textAlign: {
      xs: 'center',
      sm: 'left',
    },
  },
}

export default styles
